import {
    SET_HORIZON_LENGTH,
    SET_SELECTED_FINANCING,
    SET_PIE_SLIDER,
    TOGGLE_ANNUAL_MONTH,
    TOGGLE_LOADING,
    TOGGLE_DELETE,
    TOGGLE_PROPOSAL_VIEW,
} from './constants';

export const setHorizonLengthChange = horizonLength => ({
    type: SET_HORIZON_LENGTH,
    horizonLength,
});

export const setSelectedFinancing = selectedFinancing => ({
    type: SET_SELECTED_FINANCING,
    selectedFinancing,
});

export const setYearSliderChange = doughnutSlider => ({
    type: SET_PIE_SLIDER,
    doughnutSlider,
});

export const toggleAnnualMonth = annualMonth => ({
    type: TOGGLE_ANNUAL_MONTH,
    annualMonth,
});

export const toggleLoading = loading => ({
    type: TOGGLE_LOADING,
    loading,
});

export const setToggleDelete = toggleDelete => ({
    type: TOGGLE_DELETE,
    toggleDelete,
});
export const setToggleView = toggleView => ({
    type: TOGGLE_PROPOSAL_VIEW,
    toggleView,
});



// WEBPACK FOOTER //
// ./src/containers/common/settings/actions.js